/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc
 */
import * as References from './BreezeAssistantPublicArtifactsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc#resolvePublicShareLink
 */
export const RESOLVE_PUBLIC_SHARE_LINK_MUTATION_FIELD_NAME = 'com_hubspot_breeze_assistant_interactive_experience_rpc_BreezeAssistantPublicArtifactsRpc_resolvePublicShareLink';
export const RESOLVE_PUBLIC_SHARE_LINK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESOLVE_PUBLIC_SHARE_LINK_MUTATION_FIELD_NAME,
  args: ['accessToken', 'password'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.resolvePublicShareLinkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc#exportPublicSharePptx
 */
export const EXPORT_PUBLIC_SHARE_PPTX_MUTATION_FIELD_NAME = 'com_hubspot_breeze_assistant_interactive_experience_rpc_BreezeAssistantPublicArtifactsRpc_exportPublicSharePptx';
export const EXPORT_PUBLIC_SHARE_PPTX_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: EXPORT_PUBLIC_SHARE_PPTX_MUTATION_FIELD_NAME,
  args: ['accessToken', 'password'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.exportPublicSharePptxRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc#exportPublicSharePdf
 */
export const EXPORT_PUBLIC_SHARE_PDF_MUTATION_FIELD_NAME = 'com_hubspot_breeze_assistant_interactive_experience_rpc_BreezeAssistantPublicArtifactsRpc_exportPublicSharePdf';
export const EXPORT_PUBLIC_SHARE_PDF_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: EXPORT_PUBLIC_SHARE_PDF_MUTATION_FIELD_NAME,
  args: ['accessToken', 'password'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.exportPublicSharePdfRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.assistant.interactive.experience.rpc.BreezeAssistantPublicArtifactsRpc#getPublicShareDeckRuntime
 */
export const GET_PUBLIC_SHARE_DECK_RUNTIME_MUTATION_FIELD_NAME = 'com_hubspot_breeze_assistant_interactive_experience_rpc_BreezeAssistantPublicArtifactsRpc_getPublicShareDeckRuntime';
export const GET_PUBLIC_SHARE_DECK_RUNTIME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_PUBLIC_SHARE_DECK_RUNTIME_MUTATION_FIELD_NAME,
  args: ['accessToken', 'password'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getPublicShareDeckRuntimeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});